
 <!--<div class="container-banner">
    <div class="section-banner">
        <div class="banner-header ">
            <div class="row">
                <h1 class="text-left wow mr-auto col-12 ">{{ 'HomeGreentingIdealCar' | translate }} </h1>
               <div class="wow rollIn  plan-your-trip"> {{ 'Plan' | translate }}<br > <span>{{ 'your' | translate }}</span><br />{{ 'Trip' | translate }} </div>
                <div class="wow rollIn  plan-your-trip">{{ 'PlanYourTrip' | translate }} </div> 
            </div>
        </div>
        <div style="direction: ltr !important;" class="text-center row">
            <div class="col-10 pr-md-0">
                <img class="banner-img img-fluid" src="assets/img/banner2.svg">
            </div>
            <div style="margin-left: -20px;" class="col-2 p-0 d-flex align-items-end">
                <img class="img-fluid wow bounceInRight banner-img-car" src="assets/img/car.svg">
                <img style="margin-left:-15px;" width="15px" class="wow bounceIn banner-img-car banner-img-smoke" src="assets/img/smoke.svg">
            </div>   
        </div>     
    </div>
</div>
-->
<div class="blue-bg">
    <div class="max-page-width">
        <div *ngIf="HomeBanner != null">
            <div [innerHTML]="HomeBanner.contentText | translate"></div>
        </div>
    </div>  
  

</div>


  